angular.module('CarsSaraBo').directive('saraInput', function () {
	return {
		restrict: 'E',
		controller: [SaraInputController],
		controllerAs: 'ctrl',
		bindToController: {
			messages: '=',
			output: '=',
			error: '=',
			name: '=',
			maxlength:'=',
			minlength:'='
		},
		templateUrl: 'templates/commons/form/input/input.component.html',
		scope: {} // isolated scope
	};
});

function SaraInputController() {
	var vm = this;

	vm.updateValidation = function () {
		if (vm.error != undefined) {
			vm.error = null;
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/app/commons/form/input/input.component.js
// module id = 927
// module chunks = 3